import { KYDAdminEventSummary } from "./KYDEvent";
import { Price } from "./KYDTicket";
import { IKYDUser } from "./KYDUser";
import { KYDContact, KYDSegment } from "./KYDCampaign";

export enum AlgoliaIndexType {
  EVENTS = "EVENTS",
  ORGANIZATIONS = "ORGANIZATIONS",
  ATTENDEES = "ATTENDEES",
  CONTACTS = "CONTACTS",
  SEGMENTS = "SEGMENTS",
}

export type AlgoliaSortOrder = "ascending" | "descending";

export interface AlgoliaSegmentObject extends KYDSegment {
  objectID: string;
  created_at_unix: number;
  _tags?: string[];
}

export interface AlgoliaEventObject extends KYDAdminEventSummary {
  objectID: string;
  start_at_unix: number;
  _tags?: string[];
}

export interface AlgoliaContactObject extends KYDContact {
  objectID: string;
  last_active_at_unix: number;
  _tags?: string[];
}

export interface TicketTransaction {
  payment_id?: string;
  number_of_tickets?: number;
  ticket_ids: string[];
  display_total?: string;
  created_at: string;
}

export interface AlgoliaAttendeeObject extends IKYDUser {
  objectID: string;
  tickets_count: number;
  phone_number_parts: string[];
  phone_number_display: string;
  on_guestlist: boolean;
  notes?: string;
  updated_at: string;
  _tags?: string[];
  kyd_tags?: string[];
  ticket_type_ids: string[];
}

export interface AlgoliaTicket {
  id: string;
  ticket_type_id: string;
  attended_at?: string;
  purchased_at?: string;
  sale?: {
    source?: string;
    tender_type?: string;
    created_at?: string;
    total?: Price;
    display_total?: string;
    payment_id?: string;
  };
}
